import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  SERVICE_FACEBOOK,
  SERVICE_GOOGLEBUSINESS,
  SERVICE_INSTAGRAM,
  SERVICE_LINKEDIN,
  SERVICE_MASTODON,
  SERVICE_PINTEREST,
  SERVICE_STARTPAGE,
  SERVICE_TIKTOK,
  SERVICE_TWITTER,
  SERVICE_YOUTUBE,
} from '~/constants';
import {
  Facebook,
  Gbp,
  Instagram,
  LinkedIn,
  Mastodon,
  Pinterest,
  StartPage,
  Tiktok,
  Twitter,
  Youtube,
} from '@bufferapp/ui/Icon';
import {
  facebook,
  googlebusiness,
  instagram,
  linkedin,
  mastodon,
  pinterest,
  startpage,
  tiktok,
  twitter,
  youtube,
} from '@bufferapp/ui/style/colors';

export const IconWrapper = styled.div`
  bottom: 0;
  right: 0;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: ${(props) => (props.bgColor ? props.bgColor : '#777')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const networkIconMap = new Map([
  [SERVICE_TWITTER, { component: Twitter, color: twitter }],
  [SERVICE_FACEBOOK, { component: Facebook, color: facebook }],
  [SERVICE_LINKEDIN, { component: LinkedIn, color: linkedin }],
  [SERVICE_PINTEREST, { component: Pinterest, color: pinterest }],
  [SERVICE_INSTAGRAM, { component: Instagram, color: instagram }],
  [SERVICE_TIKTOK, { component: Tiktok, color: tiktok }],
  [SERVICE_GOOGLEBUSINESS, { component: Gbp, color: googlebusiness }],
  [SERVICE_STARTPAGE, { component: StartPage, color: startpage }],
  [SERVICE_MASTODON, { component: Mastodon, color: mastodon }],
  [SERVICE_YOUTUBE, { component: Youtube, color: youtube }],
]);

const ChannelIcon = ({ network, circular }) => {
  const icon = networkIconMap.get(network);
  if (icon) {
    const { component: IconComponent, color } = icon;
    if (circular)
      return (
        <IconWrapper bgColor={color}>
          <IconComponent size="small" color="white" />
        </IconWrapper>
      );
    return <IconComponent color={color} />;
  }
  return null;
};

ChannelIcon.propTypes = {
  network: PropTypes.oneOf([
    'facebook',
    'pinterest',
    'twitter',
    'linkedin',
    'instagram',
    'tiktok',
    'googlebusiness',
    'startPage',
    'mastodon',
    'youtube',
  ]).isRequired,
  circular: PropTypes.bool,
};

ChannelIcon.defaultProps = {
  circular: false,
};

export default ChannelIcon;
